import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export function showSuccessMessage(message: any) {
    toast.success(message, {
        theme: "colored",
        autoClose: 2000,
        style: {
            color: "#ffffff",
            background: "#744FE8",
            fontSize: "14px",
            fontWeight: 500,
            position: "absolute",
            top: "5.5vh",
            right: "0",

        },
        toastId: "",
    });
}


export function showErrorMessage(message: any) {
    toast.error(message, {
        theme: "colored",
        autoClose: 2000,
        style: {
            fontSize: "14px",
        },
        toastId: ""
    });
}